(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .directive('swifSitesOrEquipments', swifSitesOrEquipments);

    /**
        * @ngdoc directive
        * @name swif.patrimoine:swifSitesOrEquipments
        * @module swif.patrimoine
        * @restrict E
        * @description sites or equipments
        * @usage
        <swif-sites-or-equipments ng-model="model"></swif-sites-or-equipments>
    **/
    function swifSitesOrEquipments(swif) {
        'ngInject';
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.ngModel = '=';
        d.link = function (scope, element, attr, ngModel) {
            swif.form.watchNgRequired(scope, element);
            swif.form.copyAttributesToInput(scope, element, attr);
            scope.form = scope.$parent.form;
            scope.filters = {};
            scope.choices = {
                siteOrEquipment: [
                    {
                        id: 'site',
                        name: 'Site',
                        icon: '<i class="fa fa-map-marker fa-fw"></i>',
                        type: 'site',
                        field: 'site_ids',
                        categoryType: 'site_category'
                    },
                    {
                        id: 'equipment',
                        name: 'Equipment',
                        icon: '<i class="fa fa-wrench fa-fw"></i>',
                        type: 'equipment',
                        field: 'equipment_ids',
                        categoryType: 'equipment_category'
                    }
                ]
            };

            // @param choice: (object) choice to which update the selection
            // @note: this method update the internal value of the dropdown btns
            scope.setSiteOrEquipment = function (choice) {
                var newChoice = scope.choices.siteOrEquipment[0];
                if(choice.id === 'equipment') {
                    newChoice = choice;
                }
                // if contentType changes => clear the selected items
                // - update ui-select setting
                if(!angular.equals(newChoice, scope.selectedChoice)) {
                    scope.selectedChoice = newChoice;
                    scope.proxy._siteOrEquipment = [];
                }
            };

            // @param newV: (Array) list of service ids
            // @note: filter sites/equipments using service ids (both have same domain)
            scope.updateSiteOrEquipmentFilter = function (service_id) {
                var filter = {};

                var filterField = scope.selectedChoice.id == 'equipment' ?
                    'maintenance_service_ids' : 'service_ids';

                if (service_id) {
                    swif.data.addFilter(filter, '|');
                    swif.data.addFilter(filter, filterField + '.id', '=', service_id[0]);
                }
                swif.data.addFilter(filter, filterField, '=', false);
                scope.filters.siteOrEquipment = filter;

                // @todo: fetch only categories where sites are present
                scope.filters.siteOrEquipmentCategory = {};
            };

            // when (re-)initializeing the directive model:
            // - update the dropdown btns value
            // - update the proxy values to display,
            // - and finally (re-)compute the filter using service ids
            ngModel.$render = function () {
                var vv = ngModel.$viewValue;
                scope.proxy = vv;
                // try to initialize site or equipment, according to 'patrimoine_is_equipment'
                var index = vv.patrimoine_is_equipment ? 1 : 0;
                scope.setSiteOrEquipment(scope.choices.siteOrEquipment[index]);
                scope.proxy._siteOrEquipment = scope.proxy[scope.selectedChoice.field];
                scope.proxy._bycCategory = false;
                scope.updateSiteOrEquipmentFilter(vv.service_id);
            };

            // watch over service_id to filter site / equipment with it
            scope.$watch('proxy.service_id', function (newV, oldV) {
                if(!angular.equals(newV, oldV)) {
                    scope.updateSiteOrEquipmentFilter(newV);
                }
            });

            // main watcher: when triggered, commit values to the viewValue
            // values committed:
            // - site_or_equipment (bool): using scope.selectedChoice
            // - site/equipment_ids (m2m): using scope._siteOrEquipment and choice.field
            scope.$watchGroup(
                ['proxy._siteOrEquipment', 'selectedChoice'],
                function(newV, oldV) {
                    if(!angular.equals(newV, oldV)) {
                        // 'choice' is a shortcut to lower the width of code
                        var choice = newV[1];
                        var tempModel = ngModel.$viewValue;
                        tempModel.patrimoine_is_equipment = choice.id === 'equipment';
                        tempModel[choice.field] = scope.proxy._siteOrEquipment || [];
                        // we have to reset too the old values (the other contentType)
                        if(!angular.equals(newV[1], oldV[1])) {
                            tempModel[oldV[1].field] = [];
                        }
                        ngModel.$setViewValue(tempModel);
                        ngModel.$render();
                    }
                }
            );

            // this watcher is used to listen the changes coming outside
            // the directive, for example when a controller
            // want to change the values
            scope.$watchGroup(
                ['ngModel.site_ids', 'ngModel.equipment_ids'],
                function (newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        // decide which field we have to compare with _siteOrEquipment
                        // according to scope.selectedChoice
                        var i = scope.selectedChoice.id === 'equipment' ? 1: 0;
                        // if proxy is different from internal hash, it means
                        // that its value was modified from outside the directive
                        // so, we have to recompute the internal hash of data
                        if (!angular.equals(scope.proxy._siteOrEquipment, newV[i])) {
                            ngModel.$render();
                        }
                    }
                }
            );

            scope.$watch('proxy._bycCategory', function (newV, oldV) {
                if(!angular.equals(newV, oldV) && newV) {
                    var choice = scope.selectedChoice;
                    var filter = angular.copy(scope.filters.siteOrEquipment);
                    filter.fields = ['id', 'name', 'complete_name'];
                    if (choice.type === 'site') {
                        swif.data.addFilter(filter, '|');
                        swif.data.addFilter(filter, 'type_ids', '=', newV[0]);
                        swif.data.addFilter(filter, 'type_id', '=', newV[0]);
                    } else if (choice.type === 'equipment') {
                        swif.data.addFilter(filter, 'categ_id', '=', newV[0]);
                    }
                    swif.data.searchRead(choice.type, filter)
                    .then(function (result) {
                        scope.proxy._siteOrEquipment = _.union(
                            scope.proxy._siteOrEquipment,
                            _.pluck(result.records, 'id')
                        );
                    });
                    scope.proxy._bycCategory = false;
                }
            });
        };
        d.templateUrl = 'partials/patrimoine/form_sites_or_equipments_directive.html';
        return d;
    }

})();
